var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhoneOutgoing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#b0bec5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22 8v-6h-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 8 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.0004 16.9201v3c.0012.2785-.0559.5542-.1675.8093-.1115.2552-.2752.4843-.4804.6726-.2052.1882-.4475.3316-.7113.4208-.2639.0892-.5434.1224-.8208.0973-3.0771-.3344-6.033-1.3859-8.63-3.07-2.41615-1.5353-4.46464-3.5838-5.99998-6-1.69002-2.6088-2.74176-5.57901-3.07-8.67-.02499-.27654.00788-.55524.0965-.81838.08863-.26313.23107-.50493.41827-.71.18719-.20507.41504-.36891.66902-.4811.25399-.11219.52855-.17026.80621-.17052h3c.48531-.00478.95579.16708 1.32376.48353s.60832.75591.67624 1.23647c.12662.96006.36145 1.90272.7 2.81.13455.35792.16366.74691.08391 1.12088-.07976.37396-.26505.71723-.53391.98912l-1.27 1.27c1.42356 2.5035 3.49648 4.5764 5.99998 6l1.27-1.27c.2719-.2689.6152-.4542.9891-.5339.374-.0798.763-.0506 1.1209.0839.9073.3385 1.85.5734 2.81.7.4858.0685.9294.3132 1.2466.6875.3171.3743.4856.8521.4734 1.3425z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneOutgoing);
export default __webpack_public_path__ + "static/media/icon_phone_outgoing.7ff1895c455f1b86200db6e60a085187.svg";
export { ForwardRef as ReactComponent };